import type { ReactNode } from "react";
import { cn } from "@wags/ui/ui-utils";
import WagsLogo from "@/assets/icons/wags-logo.svg";

export type DogPhotoWellState = "pending" | "photos" | "empty";

export function resolveDogPhotoWellState(input: {
    photoCount: number;
    listingPagePending: boolean;
}): DogPhotoWellState {
    if (input.photoCount > 0) return "photos";
    if (input.listingPagePending) return "pending";
    return "empty";
}

function DogPhotoWellSkeleton({ state }: { state: "pending" | "empty" }) {
    return (
        <div
            aria-hidden="true"
            data-listing-photo-well={state}
            className="flex h-[calc(100%+var(--listing-media-bottom-inset,0px))] w-full items-center justify-center bg-(--brown)"
        >
            <WagsLogo
                className={cn(
                    "h-16 w-auto text-true-white",
                    state === "pending"
                        ? "animate-listing-photo-well-breathe"
                        : "opacity-35",
                )}
            />
        </div>
    );
}

export function DogListingPhotoWell({
    state,
    children,
}: {
    state: DogPhotoWellState;
    children: ReactNode;
}) {
    if (state === "photos") return children;
    return <DogPhotoWellSkeleton state={state} />;
}
